export default "__VITE_ASSET__CsoZap$D__"